import React from 'react';
import './AlertBanner.scss';
import { AlertsAndNotification } from '../../store/types';

interface AlertBannerProps {
  alert: AlertsAndNotification;
  onAction: (alert: AlertsAndNotification) => void;
  onClose: (alertId: string) => void;
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  alert,
  onAction,
  onClose
}) => {
  return (
    <div className="alerts-notification-banner" role="alert">
      {/* Icon */}
      <div className="alerts-notification-banner__icon">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.564 1.527 1.057 14.94A.5.5 0 0 0 1.493 15.69h15.014a.5.5 0 0 0 .436-.75L9.436 1.527a.5.5 0 0 0-.872 0ZM10 12.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-2.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75Z"
            fill="currentColor"
          />
        </svg>
      </div>

      {/* Content */}
      <div className="alerts-notification-banner__content">{alert.uiCopy}</div>

      {/* Button and Close */}
      <div className="alerts-notification-banner__actions">
        {/* Action Button */}
        <button
          className="alerts-notification-banner__action-button"
          onClick={() => onAction(alert)}
          aria-label={alert.ctaLabel || 'Action'}
        >
          Action
        </button>

        {/* Divider */}
        <div className="alerts-notification-banner__divider" />

        {/* Close Button */}
        <button
          className="alerts-notification-banner__close-button"
          onClick={() => onClose(alert.id)}
          aria-label="Close alert"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
          >
            <g clipPath="url(#clip0_17183_17934)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.23813 3.99993L7.69437 1.54393C7.85858 1.37979 7.95087 1.15714 7.95092 0.924955C7.95097 0.692772 7.85878 0.470078 7.69464 0.305864C7.5305 0.14165 7.30784 0.0493671 7.07566 0.0493164C6.84348 0.0492658 6.62078 0.141452 6.45657 0.305594L4.00015 2.76201L1.54349 0.305594C1.37928 0.141517 1.15661 0.0493931 0.924471 0.0494897C0.692334 0.0495862 0.469743 0.141895 0.305665 0.306109C0.141588 0.470323 0.049464 0.692991 0.0495606 0.925128C0.0496572 1.15727 0.141966 1.37986 0.30618 1.54393L2.76224 3.99993L0.30618 6.45598C0.142701 6.62021 0.0510191 6.84257 0.0512386 7.0743C0.0514581 7.30602 0.143561 7.5282 0.307351 7.69212C0.471141 7.85604 0.69325 7.94832 0.924976 7.94873C1.1567 7.94913 1.37913 7.85762 1.54349 7.69427L4.00015 5.23785L6.45657 7.69427C6.62078 7.85842 6.84346 7.9506 7.07564 7.95056C7.30782 7.95051 7.53047 7.85824 7.69461 7.69403C7.85876 7.52982 7.95095 7.30713 7.9509 7.07496C7.95085 6.84278 7.85858 6.62013 7.69437 6.45598L5.23813 3.99993Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_17183_17934">
                <rect width="8" height="8" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  );
};
